export default class extends Error {
  message = 'This account has not been verified yet';
}
